import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
	MfaReAuthBeginResponse,
	MfaReAuthVerifyResponse,
	MfaChallengeStartResponse,
	MfaChallengeResendResponse,
	MfaChallengeSwitchResponse
} from '../models/mfa';

@Injectable()
export class MfaReAuthService {

	constructor(private _http: HttpClient) {}

	beginReAuth(): Observable<MfaReAuthBeginResponse> {
		return this._http.post<MfaReAuthBeginResponse>(
			`${environment.apiUrl}/v2/MfaReAuth/Begin`,
			{}
		);
	}

	startReAuth(method: string, challengeSessionId: string): Observable<MfaChallengeStartResponse> {
		return this._http.post<MfaChallengeStartResponse>(
			`${environment.apiUrl}/v2/MfaReAuth/Start`,
			{ method, challengeSessionId }
		);
	}

	verifyReAuth(sessionId: string, code: string, method: string): Observable<MfaReAuthVerifyResponse> {
		return this._http.post<MfaReAuthVerifyResponse>(
			`${environment.apiUrl}/v2/MfaReAuth/Verify`,
			{ sessionId, code, method }
		);
	}

	resendOtp(sessionId: string): Observable<MfaChallengeResendResponse> {
		return this._http.post<MfaChallengeResendResponse>(
			`${environment.apiUrl}/v2/MfaReAuth/Resend`,
			{ sessionId }
		);
	}

	switchMethod(sessionId: string): Observable<MfaChallengeSwitchResponse> {
		return this._http.post<MfaChallengeSwitchResponse>(
			`${environment.apiUrl}/v2/MfaReAuth/Switch`,
			{ sessionId }
		);
	}

	// Re-auth counterpart of MfaChallengeService.cancelSwitch — see there (FIX-15).
	cancelSwitch(sessionId: string): Observable<MfaChallengeSwitchResponse> {
		return this._http.post<MfaChallengeSwitchResponse>(
			`${environment.apiUrl}/v2/MfaReAuth/Switch/Cancel`,
			{ sessionId }
		);
	}
}
